export default __webpack_public_path__ + "static/media/mask.a2ebf7ac.svg";